import styled from '@emotion/styled';

export const LoopTag = styled.div`
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  padding: 0 4px;
  background: var(--fett-bg-info-tip);
  color: var(--fett-scenario-accent-text);
  width: fit-content;
  flex-shrink: 0;
`;

export const FixedTag = styled.div`
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  padding: 0 4px;
  background: var(--fett-surface-warning-bg);
  color: var(--fett-surface-warning-text);
  width: fit-content;
  flex-shrink: 0;
`;

export const ExtraTag = styled.div`
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  padding: 0 4px;
  background: var(--fett-surface-success-bg);
  color: var(--fett-scenario-success-text);
  width: fit-content;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
